export function chf(n, currency = "CHF") {
  const v = Number(n || 0);
  return new Intl.NumberFormat("fr-CH", { style: "currency", currency, maximumFractionDigits: 0 }).format(v);
}

export function fdate(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("fr-CH", { day: "numeric", month: "long", year: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function fdateShort(iso) {
  if (!iso) return "—";
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// Swiss display format: jj.mm.aaaa (display only — never mutates stored values)
export function fdateCH(iso) {
  if (!iso) return "—";
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}

// Swiss date + time: jj.mm.aaaa à hh:mm
export function fdatetimeCH(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} à ${p(d.getHours())}:${p(d.getMinutes())}`;
}

// Relative "last activity" with coarse buckets; unknown when never recorded.
export function activityAgo(iso) {
  if (!iso) return "Activité inconnue";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "Activité inconnue";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 300) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  const days = Math.floor(diff / 86400);
  if (days < 7) return `il y a ${days} jour${days > 1 ? "s" : ""}`;
  if (days < 30) return `il y a ${Math.floor(days / 7)} semaine${Math.floor(days / 7) > 1 ? "s" : ""}`;
  if (days < 365) return `il y a ${Math.floor(days / 30)} mois`;
  return `il y a ${Math.floor(days / 365)} an${Math.floor(days / 365) > 1 ? "s" : ""}`;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  return `il y a ${Math.floor(diff / 86400)} j`;
}

export const RSVP_LABELS = {
  attending: "Confirmé", declined: "Décliné", awaiting: "En attente", maybe: "Peut-être",
  draft: "Brouillon", invited: "Invité", cancelled: "Annulé", responded: "Répondu",
};

export const RSVP_COLORS = {
  attending: "bg-sage/15 text-sage border-sage/30",
  declined: "bg-destructive/10 text-destructive border-destructive/20",
  awaiting: "bg-amber-100 text-amber-700 border-amber-200",
  maybe: "bg-blue-50 text-blue-700 border-blue-200",
  draft: "bg-stone-100 text-stone-500 border-stone-200",
};
